import { TagPreview, TagsOrderBy, TagsService } from "../client"

/* Interfaces */
export interface TagsTableProps {
    searchValue: string
    tg_update: boolean
    tg_delete: boolean
}

export interface AddTagProps {
    onClose: () => void
    isOpen: boolean
}

export interface EditTagProps {
    onClose: () => void
    isOpen: boolean
    tag: TagPreview
}


/* Endpoints */
export const readTags = ({
    per_page,
    page,
    order_by,
    descending,
    query,
}: {
    per_page: number,
    page: number
    order_by?: TagsOrderBy
    descending?: boolean
    query?: string
}) => {
    return {
        queryFn: async () => {
        const data = await TagsService.readTags({
            skip: (page - 1) * per_page,
            limit: per_page,
            orderBy: order_by,
            descending: descending,
            query: query,
        })

        return data ?? { data: null, count: 0 }
        },
        queryKey: ["tags", { page, order_by, descending, query }],
    }
}